import React from "react";
import MainLayout from "./MainLayout";
import PageNotFound from "../common/MainContent/Home/PageNotFound";

const NotFound = (props) => <MainLayout component={PageNotFound} />;

export default NotFound;
